<template>
  <div>
    <div v-if="isDevEnv" style="margin-bottom: 16px;">
      <b-button variant="outline-primary" @click="fillTestData" :disabled="disabledFields">Preencher dados de teste</b-button>
    </div>

    <h4 class="mb-1 mt-1">{{ $t('incident_form.title_01') }}</h4>
    <hr>

    <!--Responsible Email-->
     <b-form-group
      :label="'A) ' + $t('incident_form_responsible_email')"
      label-for="incident_form_responsible_email">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_responsible_email')"
              rules="required|email">
          <b-form-input
            id="incident_form_responsible_email"
            v-model="responsibleEmail"
            :state="errors.length > 0 ? false:null"
            name="responsibleEmail"
            class="required"
            :disabled="disabledFields"
            type="email"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Incident Group -->
    <b-form-group
      :label="'B) ' + $t('incident_form_group')"
      label-for="incidentGroupListSelected">
      <validation-provider
        #default="{ errors }"
        :name="$t('incident_form_group')"
        rules="required">
          <b-form-checkbox-group
            v-model="incidentGroupListSelected"
            :options="incidentGroupList"
            value-field="id"
            text-field="name"
            name="incidentGroupListSelected"
            :disabled="disabledFields"
            stacked/>
              <b-form-input v-if="enableIncidentGroupOther"
                id="otherGroup"
                v-model="otherGroup"
                :state="errors.length > 0 ? false:null"
                name="otherGroup"
                :disabled="disabledFields"
                class="mt-1"/>
            <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Identification Authority Controller -->
    <b-form-group
      :label="'C) ' + $t('incident_form_authority_identification')"
      label-for="incident_form_authority_identification">
        <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_authority_identification')"
          rules="required">
          <v-select v-model="legalEntity" :options="listLegal" label="name" class="required-select" :disabled="disabledFields">
            <div slot="no-options">{{$t('msg_none')}}</div>
          </v-select>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
    </b-form-group>

    <!-- Operator identification -->
    <b-form-group
      :label="'D) ' + $t('incident_form_operator_identification')+` (${$t('when_applicable')})`"
      label-for="incident_form_operator_identification">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_operator_identification')"
          rules="max:256">
          <b-form-input
            ref="operatorIdentificationInput"
            id="operator_identification"
            v-model="operatorIdentification"
            :state="errors.length > 0 ? false:null"
            :disabled="disabledFields"
            name="operatorIdentification"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Data Authority Description -->
     <b-form-group
      :label="'E) ' + $t('incident_form_data_authority_description')"
      label-for="incident_form_data_authority_description">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_data_authority_description')"
          rules="required">
          <b-form-textarea
            id="data_authority_description"
            v-model="dataAuthorityDescription"
            :state="errors.length > 0 ? false:null"
            name="dataAuthorityDescription"
            class="required"
            :disabled="disabledFields"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Who Reported -->
    <b-form-group
      :label="'F) ' + $t('incident_form_who_reported')+$t('incident_form_name_tel_email')"
      label-for="incident_form_who_reported">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_who_reported')"
          rules="required">
          <b-form-textarea
            id="incident_form_who_reported"
            v-model="whoReported"
            :state="errors.length > 0 ? false:null"
            name="whoReported"
            class="required"
            :disabled="disabledFields"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

     <!-- Responsible Unit -->
     <b-form-group
      :label="'G) ' + $t('incident_form_responsible_unit')+$t('incident_form_name_tel_email')"
      label-for="incident_form_responsible_unit">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_responsible_unit')"
          rules="required">
          <b-form-textarea
            id="incident_form_responsible_unit"
            v-model="responsibleUnit"
            :state="errors.length > 0 ? false:null"
            name="responsibleUnit"
            class="required"
            :disabled="disabledFields"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <h4 class="mb-1 mt-1">{{ $t('incident_form.title_02') }}</h4>
    <hr>

    <!-- Incident Description -->
    <b-form-group
      :label="'A) ' + $t('incident_form_description_incident')+` (${$t('incident_form_root_cause')})`"
      label-for="incident_form_description_incident">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_description_incident')"
          rules="required">
          <b-form-textarea
            id="description_incident"
            v-model="descriptionIncident"
            :state="errors.length > 0 ? false:null"
            name="descriptionIncident"
            class="required"
            :disabled="disabledFields"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Incident Acid Property -->
    <b-form-group
      :label="'B) ' + $t('incident_form_affected')"
      label-for="incidentAcidPropertyListSelected">
      <validation-provider
        #default="{ errors }"
        :name="$t('incident_form_affected')"
        rules="required">
          <b-form-checkbox-group
            v-model="incidentAcidPropertyListSelected"
            :options="incidentAcidPropertyList"
            value-field="id"
            text-field="name"
            name="incidentAcidPropertyListSelected"
            stacked
            :disabled="disabledFields"
            class="mb-2"/>
            <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

     <!-- Structure Organization Description -->
     <b-form-group
      :label="'C) ' + $t('incident_form_structure_organization_description')"
      label-for="incident_form_structure_organization_description">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_structure_organization_description')"
          rules="required">
          <b-form-textarea
            id="structure_organization_description"
            v-model="structureOrganizationDescription"
            :state="errors.length > 0 ? false:null"
            name="structureOrganizationDescription"
            class="required"
            :disabled="disabledFields"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

     <!-- How Identified -->
     <b-form-group
      :label="'D) ' + $t('incident_form_how_identified')"
      label-for="incident_form_how_identified">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_how_identified')"
          rules="required">
          <b-form-textarea
            id="incident_form_how_identified"
            v-model="howIdentified"
            :state="errors.length > 0 ? false:null"
            name="howIdentified"
            class="required"
            :disabled="disabledFields"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Holders Report -->
    <b-form-group
      :label="'E) ' + $t('incident_form_holders_report') + ' ' + $t('incident_form_case_yes_contact')"
      label-for="incident_form_holders_report">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_holders_report')">
          <b-form-input
            id="incident_form_holders_report"
            v-model="holdersReport"
            :state="errors.length > 0 ? false:null"
            :disabled="disabledFields"
            name="holdersReport"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- ANPD Report Incident -->
    <b-form-group
      :label="'F) ' + $t('incident_form_anpd_report_incident')"
      label-for="incident_form_anpd_report_incident">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_anpd_report_incident')"
          rules="required">
          <b-form-textarea
            id="incident_form_anpd_report_incident"
            v-model="anpdReportIncident"
            :state="errors.length > 0 ? false:null"
            name="anpdReportIncident"
            class="required"
            :disabled="disabledFields"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <h4 class="mb-1 mt-1">{{ $t('incident_form.title_03') }}</h4>
    <hr>

    <!-- Incident Leaked -->
    <b-form-group
      :label="'A) ' + $t('incident_form_leaked_content')"
      label-for="incidentLeakedContentListSelected">
      <validation-provider
        #default="{ errors }"
        :name="$t('incident_form_leaked_content')"
        rules="required">
          <b-form-checkbox-group
            v-model="incidentLeakedContentListSelected"
            :options="incidentLeakedContentList"
            value-field="id"
            text-field="name"
            name="incidentLeakedContentListSelected"
            stacked
            :disabled="disabledFields"
            class="mb-2"/>
            <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

     <!-- Category Personal Data -->
     <b-form-group
      :label="'B) ' + $t('category_personal_data')"
      label-for="category_personal_data">
      <validation-provider
          #default="{ errors }"
          :name="$t('category_personal_data')"
          rules="required">
          <b-form-textarea
            id="category_personal_data"
            v-model="categoryPersonalData"
            :state="errors.length > 0 ? false:null"
            name="categoryPersonalData"
            class="required"
            :disabled="disabledFields"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Data Old or New -->
    <b-form-group
      :label="'C) ' + $t('incident_form_data_old_or_new')"
      label-for="incident_form_data_old_or_new">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_data_old_or_new')"
          rules="required">
          <b-form-textarea
            id="data_old_or_new"
            v-model="dataOldOrNew"
            :state="errors.length > 0 ? false:null"
            name="dataOldOrNew"
            class="required"
            :disabled="disabledFields"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- number_affected_holders -->
    <b-form-group
      :label="'D) ' + $t('number_affected_holders')"
      label-for="number_affected_holders">
      <validation-provider
          #default="{ errors }"
          :name="$t('number_affected_holders')"
          rules="required">
          <b-form-input
            ref="number_affected_holdersInput"
            id="number_affected_holders"
            v-model="numberAffectedHolders"
            :state="errors.length > 0 ? false:null"
            type="number"
            @keyup="validateNumberAffectedHolders"
            name="number_affected_holders"
            :disabled="disabledFields"
            class="required"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Total Affected Holders -->
    <b-form-group
      :label="'E) ' + $t('incident_form_total_affected_holders')+` (${$t('incident_form_total_affected_holders_01')})`"
      label-for="incident_form_total_affected_holders">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_total_affected_holders')">
          <b-form-input
            id="total_affected_holders"
            v-model="totalAffectedHolders"
            :state="errors.length > 0 ? false:null"
            :disabled="disabledFields"
            name="totalAffectedHolders"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <h4 class="mb-1 mt-1">{{ $t('incident_form.title_04') }}</h4>
    <hr>

    <!-- incident Date -->
    <b-form-group
      :label="'A) ' + $t('incident_form_date_incident')"
      label-for="incident_form_date_incident">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_date_incident')"
          rules="required">
          <flat-pickr
            v-model="incidentDate"
            class="form-control required"
            :class="{ 'is-disabled': disabledFields }"
            :config="configCalendar"
            :disabled="disabledFields"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- incident_form_date_authority -->
    <b-form-group
      :label="'B) ' + $t('incident_form_date_authority')"
      label-for="incident_form_date_authority">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_date_authority')"
          rules="required">
          <flat-pickr
            v-model="dateAuthority"
            class="form-control required"
            :class="{ 'is-disabled': disabledFields }"
            :config="configCalendar"
            :disabled="disabledFields"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Reasons Delay -->
    <b-form-group
      :label="'C) ' + $t('incident_form_reasons_delay')"
      label-for="incident_form_reasons_delay">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_reasons_delay')">
          <b-form-textarea
            id="reasons_delay"
            v-model="reasonsDelay"
            :state="errors.length > 0 ? false:null"
            :disabled="disabledFields"
            name="reasonsDelay"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <h4 class="mb-1 mt-1">{{ $t('incident_form.title_05') }}</h4>
    <hr>

    <!-- Data Protection Measures -->
    <b-form-group
      :label="'A) ' + $t('incident_form_data_protection_measures')+` (${$t('incident_form_data_protection_measures_01')})`"
      label-for="incident_form_data_protection_measures">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_data_protection_measures')"
          rules="required">
          <b-form-textarea
            id="data_protection_measures"
            v-model="dataProtectionMeasures"
            :state="errors.length > 0 ? false:null"
            name="dataProtectionMeasures"
            class="required"
            :disabled="disabledFields"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- incident_form_actions_reverse_incident -->
    <b-form-group
      :label="'B) ' + $t('incident_form_actions_reverse_incident')"
      label-for="incident_form_actions_reverse_incident">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_actions_reverse_incident')"
          rules="required">
          <b-form-textarea
            id="actions_reverse_incident"
            v-model="actionsReverseIncident"
            :state="errors.length > 0 ? false:null"
            name="actionsReverseIncident"
            class="required"
            :disabled="disabledFields"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Other Description -->
    <b-form-group
      :label="'C) ' + $t('incident_form_other_description')+` (${$t('incident_form_other_description_01')})`"
      label-for="incident_form_other_description">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_other_description')">
          <b-form-textarea
            id="incident_form_other_description"
            v-model="otherDescription"
            :state="errors.length > 0 ? false:null"
            :disabled="disabledFields"
            name="otherDescription"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <h4 class="mb-1 mt-1">{{ $t('incident_form.title_06') }}</h4>
    <hr>

    <!-- Related Risks -->
    <b-form-group
      :label="'A) ' + $t('incident_form_related_risks')"
      label-for="incident_form_related_risks">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_related_risks')"
          rules="required">
          <b-form-textarea
            id="related_risks"
            v-model="relatedRisks"
            :state="errors.length > 0 ? false:null"
            name="relatedRisks"
            class="required"
            :disabled="disabledFields"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- comunication content -->
    <b-form-group
      :label="'B) ' + $t('incident_form_comunication_content')"
      label-for="incident_form_comunication_content">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_comunication_content')"
          rules="required">
          <b-form-textarea
            id="comunication_content"
            v-model="comunicationContent"
            :state="errors.length > 0 ? false:null"
            name="comunicationContent"
            class="required"
            :disabled="disabledFields"
            rows="4"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Communication Content attachments -->
    <b-form-group
      :label="'C) ' + $t('incident_form_communication_content_attachments')"
      label-for="incident_form_communication_content_attachments">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_communication_content_attachments')">
          <b-form-file
            id="communication_content_attachments"
            placeholder="Clique para selecionar os arquivos ou arraste aqui..."
            drop-placeholder="Solte os arquivos aqui..."
            v-model="communicationContentAttachments"
            :state="errors.length > 0 ? false:null"
            name="communicationContentAttachments"
            :disabled="disabledFields"
            multiple
            accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"/>
          <small class="text-danger">{{ errors[0] }}</small>
          <small class="form-text text-muted">
            <i class="feather icon-upload mr-1"></i>
            Selecione um ou mais arquivos para anexar. Todos os anexos são opcionais.
          </small>
          <div v-if="communicationContentAttachments && communicationContentAttachments.length" class="mt-2">
            <b-list-group>
              <b-list-group-item v-for="(file, idx) in communicationContentAttachments" :key="file.name + file.size" class="d-flex justify-content-between align-items-center">
                <div>
                  <i class="feather icon-file-text text-primary mr-2"></i>
                  <span>{{ file.name }}</span>
                  <small class="ml-2 text-muted">({{ (file.size/1024).toFixed(1) }} KB)</small>
                </div>
                <b-button variant="outline-danger" size="sm" @click="removeAttachment(idx)" v-if="!disabledFields">
                  <i class="feather icon-trash-2"></i>
                </b-button>
              </b-list-group-item>
            </b-list-group>
          </div>
      </validation-provider>
    </b-form-group>

    <!-- ANPD Report Incident -->
    <b-form-group
      :label="'D) ' + $t('incident_form_anpd_communicated')"
      label-for="incident_form_anpd_communicated">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_anpd_communicated')"
          rules="required">
          <b-form-radio-group
            id="incident_form_anpd_communicated"
            v-model="anpdCommunicated"
            :state="errors.length > 0 ? false:null"
            name="anpdCommunicated"
            class="required"
            :options="anpdCommunicatedList"
            :disabled="disabledFields"
            stacked/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

    <!-- Reasons Lack Communication -->
    <b-form-group
      :label="'E) ' + $t('incident_form_reasons_lack_communication')"
      label-for="incident_form_reasons_lack_communication">
      <validation-provider
          #default="{ errors }"
          :name="$t('incident_form_reasons_lack_communication')"
          rules="required">
          <b-form-textarea
            id="reasons_lack_communication"
            v-model="reasonsLackCommunication"
            :state="errors.length > 0 ? false:null"
            name="reasonsLackCommunication"
            class="required"
            rows="4"
            :disabled="disabledFields"/>
          <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>

  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BFormTextarea,
  BFormFile,
  BCard,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from 'bootstrap-vue'
import { required, email, numeric, min, max } from '@validations'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'

import standard from '@/services/standard'


import RequestFormIncidentService from '@/services/api/incident/RequestFormIncidentService'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BFormFile,
    BCard,
    BCardText,
    BCardTitle,
    BCardFooter,
    BImg,
    BForm,
    BButton,
    BAlert,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    flatPickr,
  },
  props: {
    param_encrypt: {
      type: String,
      default: null
    },
    typeForm: {
      type: String,
      default: null
    },
    dataForm: {
      type: Object,
      default: null
    },
    disabledFields: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      format: 'dd/MM/yyyy',
      //
      incidentDate: '',
      dateAuthority: '',
      categoryPersonalData: '',
      otherGroup: '',
      numberAffectedHolders: '',
      dataProtectionMeasures: '',
      relatedRisks: '',
      reasonsDelay: '',
      actionsReverseIncident: '',
      dataAuthorityDescription: '',
      descriptionIncident: '',
      totalAffectedHolders: '',
      comunicationContent: '',
      communicationContentAttachments: [],
      reasonsLackCommunication: '',
      structureOrganizationDescription: '',
      dataOldOrNew: '',
      whoReported: '',
      responsibleUnit: '',
      howIdentified: '',
      howReported: '',
      operatorIdentification: '',
      holdersReport: '',
      anpdReportIncident: '',
      anpdCommunicated: '',
      anpdCommunicatedList: [
        { value: true, text: 'Sim' },
        { value: false, text: 'Não' },
      ],
      otherDescription: '',
      legalEntityOriginId: '',
      responsibleEmail: '',
      legalEntity: null,
      legalEntityList : [],
      incidentTypeListSelected : [],
      incidentGroupListSelected: [],
      incidentAcidPropertyListSelected: [],
      incidentLeakedContentListSelected: [],
      //
      //List auxiliar
      incidentTypeList: [],
      incidentAcidPropertyList: [],
      incidentLeakedContentList: [],
      incidentCoupAttemptTypeList: [],
      incidentGroupList: [],
      // validation rules
      required,
      email,

      services: {
        requestFormIncidentService : null,
      },
      isDevEnv: [
        'localhost',
        '127.0.0.1',
        '0.0.0.0',
        'dev',
        'teste',
        'test',
        'homolog',
        'homologacao',
        'staging'
      ].some(env => window.location.hostname.includes(env)),
    }
  },
  watch: {
    dataForm: {
      handler(newValue) {
        if (newValue) {
          this.handleDataForm()
          this.loadLegalEntityList()
        }
      },
      immediate: true
    },
    typeForm: {
      handler(newValue) {
        // Quando o tipo de formulário muda, recarregar a lista de entidades legais
        if (newValue && this.services.requestFormIncidentService) {
          this.loadLegalEntityList()
        }
      },
      immediate: false
    },
    enableIncidentGroupOther(value){
      if(value === false){
        this.otherGroup = null
      }
    }
  },
  computed: {
    validateForm() {
      return (
        !this.isEmpty(this.incidentDate) &&
        !this.isEmpty(this.incidentLeakedContentListSelected) &&
        !this.isEmpty(this.categoryPersonalData) &&
        !this.isEmpty(this.numberAffectedHolders) &&
        !this.isEmpty(this.incidentGroupListSelected) &&
        !this.isEmpty(this.dataProtectionMeasures) &&
        !this.isEmpty(this.relatedRisks) &&
        // reasonsDelay não é required, mas actionsReverseIncident é
        !this.isEmpty(this.actionsReverseIncident) &&
        !this.isEmpty(this.dateAuthority) &&
        !this.isEmpty(this.dataAuthorityDescription) &&
        !this.isEmpty(this.legalEntity) &&
        !this.isEmpty(this.descriptionIncident) &&
        // totalAffectedHolders não é required
        !this.isEmpty(this.comunicationContent) &&
        // communicationContentAttachments não é required
        !this.isEmpty(this.reasonsLackCommunication) &&
        !this.isEmpty(this.incidentAcidPropertyListSelected) &&
        !this.isEmpty(this.structureOrganizationDescription) &&
        !this.isEmpty(this.dataOldOrNew) &&
        !this.isEmpty(this.whoReported) &&
        !this.isEmpty(this.responsibleUnit) &&
        !this.isEmpty(this.howReported) &&
        // holdersReport não é required
        !this.isEmpty(this.anpdReportIncident) &&
        (this.anpdCommunicated === true || this.anpdCommunicated === false)
        // otherDescription não é required
      )
    },
    enableIncidentGroupOther() {
      return this.incidentGroupListSelected ? this.incidentGroupListSelected.indexOf(7) != -1 : false
    },
    listLegal(){
      if(this.legalEntityList){
          this.legalEntityList.push({
          id: null,
          name: "Outras",
          trading_name: "Outras"
        })
      }

      return this.legalEntityList
    },
    getLocale() {
      return this.$i18n.locale
    },
    configCalendar() {
      return {
        wrap: true,
        enableTime: false,
        allowInput: true,
        ariaDateFormat: 'DD/MM/YYYY',
        dateFormat: "DD/MM/YYYY",
        altFormat: "DD/MM/YYYY",
        allowInput: true,
        parseDate: (datestr, format) => {
          return this.$moment(datestr, format, true).toDate();
        },
        formatDate: (date, format, locale) => {
          // locale can also be used
          return this.$moment(date).format(format);
        },
        locale: require(`flatpickr/dist/l10n/${this.getLocale}.js`).default[this.getLocale]
      }
    },
  },
  methods: {
    getFormData() {
      return {
        incidentDate: this.incidentDate,
        dateAuthority: this.dateAuthority,
        categoryPersonalData: this.categoryPersonalData,
        otherGroup: this.otherGroup,
        numberAffectedHolders: this.numberAffectedHolders,
        dataProtectionMeasures: this.dataProtectionMeasures,
        relatedRisks: this.relatedRisks,
        reasonsDelay: this.reasonsDelay,
        actionsReverseIncident: this.actionsReverseIncident,
        dataAuthorityDescription: this.dataAuthorityDescription,
        descriptionIncident: this.descriptionIncident,
        totalAffectedHolders: this.totalAffectedHolders,
        comunicationContent: this.comunicationContent,
        communicationContentAttachments: this.communicationContentAttachments,
        reasonsLackCommunication: this.reasonsLackCommunication,
        structureOrganizationDescription: this.structureOrganizationDescription,
        dataOldOrNew: this.dataOldOrNew,
        whoReported: this.whoReported,
        responsibleUnit: this.responsibleUnit,
        howReported: this.howReported,
        howIdentified: this.howIdentified,
        holdersReport: this.holdersReport,
        anpdReportIncident: this.anpdReportIncident,
        anpdCommunicated: this.anpdCommunicated,
        otherDescription: this.otherDescription,
        legalEntityId: this.legalEntity ? this.legalEntity.id : null,
        operatorIdentification: this.operatorIdentification,
        dataSubject: this.dataSubject,
        dataAuthority: this.dataAuthority,
        additionalInformation: this.additionalInformation,
        responsibleEmail: this.responsibleEmail,
        //Arrays
        incidentGroupListSelected: this.incidentGroupListSelected,
        incidentAcidPropertyListSelected: this.incidentAcidPropertyListSelected,
        incidentLeakedContentListSelected: this.incidentLeakedContentListSelected,
        incidentCoupAttemptTypeListSelected: this.incidentCoupAttemptTypeListSelected,
      }
    },
    loadLegalEntityList(){
      // Verificar se o serviço foi inicializado
      if (!this.services.requestFormIncidentService) {
        console.log('loadLegalEntityList - service not initialized yet')
        return
      }

      this.$vs.loading()
      console.log('loadLegalEntityList - param_encrypt:', this.param_encrypt)
      console.log('loadLegalEntityList - legalEntityOriginId:', this.legalEntityOriginId)

      this.services.requestFormIncidentService.getListLegalEntity(this.param_encrypt, this.legalEntityOriginId).then(
        data => {
          console.log('loadLegalEntityList - success:', data)
          this.legalEntityList = data.list
        }
      ).catch(error => {
        console.error('loadLegalEntityList - error:', error)
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    getDataFields(){
      const params = {
              incident_date: this.incidentDate ? this.$moment(this.incidentDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
              legal_entity_id: _.get(this.legalEntity,'id'),
              responsible_unit: this.responsibleUnit,
              how_identified: this.howIdentified,
              data_subject: this.dataSubject,
              data_authority: this.dataAuthority,
              details: this.details,
              additional_information: this.additionalInformation,
              other_group: this.otherGroup,
              category_personal_data: this.categoryPersonalData,
              number_affected_holders: this.numberAffectedHolders,
              data_protection_measures: this.dataProtectionMeasures,
              related_risks: this.relatedRisks,
              reasons_delay: this.reasonsDelay,
              anpd_report_incident: this.anpdReportIncident,
              anpd_communicated: this.anpdCommunicated,
              other_description: this.otherDescription,
              how_identified: this.howIdentified,
              holders_report: this.holdersReport,
              anpd_report_incident: this.anpdReportIncident,
              anpd_communicated: this.anpdCommunicated,
              other_description: this.otherDescription,
              responsible_email: this.responsibleEmail,

              //File
              communication_content_attachments: this.communicationContentAttachments,

              //List
              incident_group_selection: this.incidentGroupListSelected,
              incident_object_selection: this.incidentObjectListSelected,
              request_acid_property_selection: this.incidentAcidPropertyListSelected,
              request_leaked_content_selection: this.incidentLeakedContentListSelected,
          }
      return params;
    },
    clearFields() {
      console.log('clearFields')
      this.incidentDate = null
      this.dateAuthority = null
      this.categoryPersonalData = null
      this.otherGroup = null
      this.numberAffectedHolders = null
      this.dataProtectionMeasures = null
      this.relatedRisks = null
      this.reasonsDelay = null
      this.actionsReverseIncident = null
      this.dataAuthorityDescription = null
      this.descriptionIncident = null
      this.totalAffectedHolders = null
      this.comunicationContent = null
      this.reasonsLackCommunication = null
      this.structureOrganizationDescription = null
      this.dataOldOrNew = null
      this.whoReported = null
      this.responsibleUnit = null
      this.howIdentified = null
      this.howReported = null
      this.operatorIdentification = null
      this.holdersReport = null
      this.anpdReportIncident = null
      this.anpdCommunicated = null
      this.otherDescription = null
      this.responsibleEmail = null
      this.legalEntity = null
      //Arrays
      this.communicationContentAttachments = []
      this.incidentTypeListSelected = []
      this.incidentAcidPropertyListSelected = []
      this.incidentLeakedContentListSelected = []
      this.incidentGroupListSelected = []

      this.$nextTick( () => {this.clearErrors(this.$validator)})

    },
    onfocusin(){
        setTimeout((ev)=>{
            this.$refs.incident_form_date.isOpen || this.$refs.incident_form_date.showCalendar(ev);
        }, 50)
    },
    errorAlertFormValidaded(){
      const firstField = this.$el.querySelector('.is-invalid')
      if(firstField){
        firstField.scrollIntoView()
      }
      this.notifyWarning(this.$vs, 'Preencha corretamente os campos do formulário!', 3000)
    },
    validateNumberAffectedHolders(event) {
      console.log('validateNumberAffectedHolders', event)
      const value = event.target.value

    },
    removeAttachment(idx) {
      if(this.dataForm && this.dataForm.id && this.communicationContentAttachments[idx].id){
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Remover anexo',
          acceptText: 'Sim',
          cancelText: 'Não',
          text: 'Tem certeza que deseja remover este anexo? Esta ação não poderá ser desfeita.',
          accept: () => this.removeAttachmentPersist(idx)
        })
      }else{
        this.communicationContentAttachments.splice(idx, 1)
      }
    },
    removeAttachmentPersist(idx){
      this.$vs.loading()
      this.services.requestFormIncidentService.deleteFile(this.dataForm.id, this.communicationContentAttachments[idx].id).then(
          data => {
            this.notifySuccess(this.$vs, 'Anexo removido com sucesso!', 4000, 'top-center')
            this.communicationContentAttachments.splice(idx, 1)
          }
        ).finally(() => {
          this.$vs.loading.close()
        })
    },
    fillTestData() {
      this.incidentDate = '01/01/2024';
      this.dateAuthority = '02/01/2024';
      this.categoryPersonalData = 'Dados pessoais teste';
      this.otherGroup = 'Outro grupo';
      this.numberAffectedHolders = 10;
      this.dataProtectionMeasures = 'Medidas de proteção teste';
      this.relatedRisks = 'Riscos relacionados teste';
      this.reasonsDelay = 'Motivo do atraso teste';
      this.actionsReverseIncident = 'Ações para reverter incidente teste';
      this.dataAuthorityDescription = 'Descrição da autoridade teste';
      this.descriptionIncident = 'Descrição do incidente teste';
      this.totalAffectedHolders = 15;
      this.comunicationContent = 'Conteúdo de comunicação teste';
      this.communicationContentAttachments = [{ name: 'arquivo_teste.pdf', size: 1024 }];
      this.reasonsLackCommunication = 'Motivo da falta de comunicação teste';
      this.structureOrganizationDescription = 'Descrição da estrutura organizacional teste';
      this.dataOldOrNew = 'Dados antigos';
      this.whoReported = 'Usuário teste';
      this.howIdentified = 'Como foi identificado teste teste at 12345';
      this.responsibleUnit = 'Unidade responsável teste';
      this.howReported = 'Como foi reportado teste';
      this.holdersReport = 'Relatório de titulares teste';
      this.anpdReportIncident = 'Relatório ANPD teste';
      this.anpdCommunicated = true;
      this.otherDescription = 'Outro teste lorem ipsum dolor sit amet';
      this.legalEntity = { id: 1, name: 'Empresa Teste' };
      this.operatorIdentification = 'Operador teste';
      this.dataSubject = 'Titular dos dados teste';
      this.dataAuthority = '03/01/2024';
      this.additionalInformation = 'Informação adicional teste';
      // Arrays
      this.incidentTypeListSelected = [1];
      this.incidentGroupListSelected = [1];
      this.incidentAcidPropertyListSelected = [1];
      this.incidentLeakedContentListSelected = [1];
    },
    handleDataForm(){
      if(this.dataForm){
        this.incidentDate = this.dataForm.incident_date
        this.dateAuthority = this.dataForm.date_authority
        this.categoryPersonalData = this.dataForm.category_personal_data
        this.otherGroup = this.dataForm.other_group
        this.numberAffectedHolders = this.dataForm.number_affected_holders
        this.dataProtectionMeasures = this.dataForm.data_protection_measures
        this.relatedRisks = this.dataForm.related_risks
        this.reasonsDelay = this.dataForm.reasons_delay
        this.actionsReverseIncident = this.dataForm.actions_reverse_incident
        this.dataAuthorityDescription = this.dataForm.data_authority_description
        this.descriptionIncident = this.dataForm.description
        this.totalAffectedHolders = this.dataForm.total_affected_holders
        this.comunicationContent = this.dataForm.comunication_content
        this.communicationContentAttachments = this.dataForm.communication_content_attachments
        this.reasonsLackCommunication = this.dataForm.reasons_lack_communication
        this.structureOrganizationDescription = this.dataForm.structure_organization_description
        this.dataOldOrNew = this.dataForm.data_old_or_new
        this.whoReported = this.dataForm.who_reported
        this.responsibleUnit = this.dataForm.responsible_unit
        this.howIdentified = this.dataForm.how_identified
        this.howReported = this.dataForm.how_reported
        this.operatorIdentification = this.dataForm.operator_identification
        this.holdersReport = this.dataForm.holders_report
        this.anpdReportIncident = this.dataForm.anpd_report_incident
        this.anpdCommunicated = this.dataForm.anpd_communicated
        this.otherDescription = this.dataForm.other_description
        this.legalEntity = this.dataForm.legal_entity ? this.dataForm.legal_entity : this.legalEntityList[this.legalEntityList.length - 1]
        this.legalEntityOriginId = this.dataForm.legal_entity_origin_id
        this.responsibleEmail = this.dataForm.responsible_email
        //Arrays
        this.incidentGroupListSelected = this.dataForm.incident_groups ? this.dataForm.incident_groups.map(group => group.id) : []
        this.incidentAcidPropertyListSelected = this.dataForm.acid_properties ? this.dataForm.acid_properties.map(property => property.id) : []
        this.incidentLeakedContentListSelected = this.dataForm.incident_leaked_contents ? this.dataForm.incident_leaked_contents.map(content => content.id) : []
        //Attachments
        this.communicationContentAttachments = this.dataForm.communication_content_attachments || []
      }
    }
  },
  mounted() {
    //console.log(this.param_encrypt)
    // handleDataForm() is now handled by the dataForm watcher

    // Carregar a lista de entidades legais quando não há dataForm (formulário novo)
    if (!this.dataForm && this.services.requestFormIncidentService) {
      this.loadLegalEntityList()
    }
  },
  beforeMount() {
    this.$vs.loading()
    const promisses = []

    //Services
    this.services.requestFormIncidentService = RequestFormIncidentService.build(this.$vs)

    promisses.push(
      this.services.requestFormIncidentService.getListIncidentAcidProperty().then(
        data => {
          this.incidentAcidPropertyList = data
        },
        error => {
          this.$vs.loading.close()
        }
      )
    )

    promisses.push(
      this.services.requestFormIncidentService.getListIncidentLeakedContent().then(
        data => {
          this.incidentLeakedContentList = data
        },
        error => {
          this.$vs.loading.close()
        }
      )
    )

    promisses.push(
      this.services.requestFormIncidentService.getListIncidentGroup().then(
        data => {
          this.incidentGroupList = data
        },
        error => {
          this.$vs.loading.close()
        }
      )
    )

    Promise.all(promisses).then(() => {
      this.$vs.loading.close()
      // Tentar carregar a lista de entidades legais depois que o serviço estiver inicializado
      if (this.dataForm) {
        this.loadLegalEntityList()
      }
    })

  }
}
</script>

<style lang="scss" scoped>
  @import '@core/scss/vue/libs/vue-flatpicker.scss';

  .radio.custom-control {
      margin-top: 5px;
  }

  .file-selector {
    padding: 55px;
    //font-weight: 600;
    background-color: #f9f9f9;
    color: #4e5b69;
    //z-index: -9;
  }
  .separator {
    position: relative;
  }
  .separator:after {
    position: absolute;
    content: "";
    height: 1px;
    width: 200px;
    background: #d8d8d8;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .separator-span {
    position: relative;
    background: #f9f9f9;
    padding: 0 4px;
    z-index: 9;
    font-size: 12px;
    color: #4e5b69;
  }
</style>

